// Components.
import { HeroSection } from "../../features/HeroSection";
import { Services } from "../../features/Services";
import { ContactModalForm } from "../../features/contactModal/ContactModalForm";
// Styles.
import { PageContainer } from "../../styles/LandingPageStyles";

export const LandingPage = () => {
  return (
    <PageContainer>
      <HeroSection />
      <Services />
      <ContactModalForm />
    </PageContainer>
  );
};
